import { createTRPCClient, httpBatchLink } from '@trpc/client';
import type { AppRouter } from '../../backend/src/trpc/router';
import auth from './auth/auth';
import { config } from './config';

export const client = createTRPCClient<AppRouter>({
    links: [
        httpBatchLink({
            url: config.trpcServerUrl,
            async headers() {
                return {
                    authorization: auth.isLoggedIn() ? `Bearer ${auth.getToken()}` : '',
                };
            },
        }),
    ],
});
